import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";

import WizardError from "../auth/register/WizardError";
import ButtonIcon from "../common/ButtonIcon";
import classNames from "classnames";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PreloadState } from "../UI/preloading/PreloadState";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { Toast } from "./../UI/toast/Toast";
// eslint-disable-next-line import/no-unresolved
import { createArea, updateArea } from "../../helpers/api/areas";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import NumberFormat from "react-number-format";
import SupportLink from "../root/support/components/SupportLink";
import FileUploadArea from "../common/FileUploadArea";
import { CurrencyContext } from "../../context/Context";


const AreasCreate = () => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { type } = useParams();
  const { state } = useLocation();
  const { baseCurrency } = useContext(CurrencyContext);
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors },
    setValue,
    watch,
  } = useForm({ mode: "onChange" });
  const history = useHistory();
  const rentalFeeValue = watch("rental_fee");
  const depositFeeValue = watch("deposit_fee");
  const [rental, setRental] = useState(false);
  const [deposit, setDeposit] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [file, setFile] = useState(null);

  console.log(errors);

  useEffect(() => {
    register("rental_fee", {
      minLength: { value: 0, message: "no puede ser 0." },
      pattern: { value: /^[0-9,. %]+$/i, message: "Solo se aceptan números." },
    });

    register("deposit_fee", {
      minLength: { value: 0, message: "no puede ser 0." },
      pattern: { value: /^[0-9,. %]+$/i, message: "Solo se aceptan números." },
    });

    let timeoutId;

    const loadData = async () => {
      if (state?.area?.id) {
        console.log("Cargando área a editar:", state.area);
        if (state.area.rental_fee) setRental(true);
        if (state.area.deposit_fee) setDeposit(true);
        if (state.area.image) setImagePreview(state.area.image);
        timeoutId = setTimeout(() => {
          setValue("name", state.area.name);
          setValue("description", state.area.description);
          setValue("deposit_fee", state.area.deposit_fee);
          setValue("people_capacity", state.area.people_capacity);
          setValue("rental_fee", state.area.rental_fee);
        }, 1000);
      } else {
        history.goBack();
      }
    };
    type !== "create" && loadData();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
    // eslint-disable-next-line
  }, []);

  const handleImageChange = (event) => {
    if (event.target.files.length !== 0) {
      setImagePreview(URL.createObjectURL(event.target.files[0]));
      register("picture");
      setValue("picture", event.target.files[0]);
      setFile(event.target.files[0]);
    }
  };

  const handleSubmitData = async (values) => {
    setSubmitting(true);
    const formData = new FormData();

    formData.append("name", values.name);
    if (values.description) formData.append("description", values.description);
    formData.append("people_capacity", values.people_capacity);

    if (rental && values.rental_fee) formData.append("rental_fee", values.rental_fee);
    if (deposit && values.deposit_fee) formData.append("deposit_fee", values.deposit_fee);

    if (file) {
      formData.append("picture", file);
    } else if (type !== "create" && !imagePreview) {
      formData.append("picture", "");
    }

    try {
      const { code } =
        type === "create"
          ? await createArea(selectedCondominium, formData)
          : await updateArea(state.area.id, formData);

      if (
        code ===
        (type === "create" ? SUCCESS_RESPONSE.CREATED : SUCCESS_RESPONSE.OK)
      ) {
        Toast.fire({
          type: "success",
          title: `Se ha ${
            type === "create" ? "creado" : "actualizado"
          } el área común satisfactoriamente.`,
        });
        history.push(`/dashboard/areas`);
      }
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <PageHeader
        title={`${type === "create" ? "Crear nueva" : "Actualizar"} área común`}
        titleTag="h2"
        description={`${type === "create"
            ? "Crear un área común del condominio y gestionala al instante."
            : "Actualiza un área común del condominio."
          }`}
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-light mb-3"
        onSubmit={handleSubmit(handleSubmitData)}
      >
        <FalconCardHeader title="Detalles del área" light={true} />
        <PreloadState
          loading={submitting}
          message={
            submitting &&
            `${type === "create" ? "Creando" : "Actualizando"
            } área común, espere un momento.`
          }
        >
          <CardBody>
            <FormGroup>
              <Label for="name">Nombre</Label>
              <Input
                id="title"
                name={"name"}
                innerRef={register({
                  required: "Nombre del área es requerido.",
                  pattern: {
                    value: /^[a-zA-Z0-9 %]+$/i,
                    message: "Solo se aceptan alfanúmericos.",
                  },
                })}
                autoComplete="off"
                placeholder="Nombre del área"
                className={classNames({
                  "border-danger": errors.name?.message,
                })}
              />
              {errors.name && (
                <WizardError
                  error={errors.name.message}
                  className="fs--1 font-weight-normal d-block"
                />
              )}
            </FormGroup>
            <Row form>
              <Col sm tag={FormGroup}>
                <Label for="people_capacity">Capacidad de personas</Label>
                <Input
                  min={1}
                  max={1000}
                  name="people_capacity"
                  type={"number"}
                  innerRef={register({
                    required: "Esto es obligatorio.",
                    minLength: {
                      value: 1,
                      message: "no puede ser menos de 1.",
                    },
                    pattern: {
                      value: /^[0-9 %]+$/i,
                      message: "Solo se aceptan números.",
                    },
                  })}
                  onKeyDown={(e) =>
                    ["KeyE", "Period", "Minus"].indexOf(e.code) !== -1 &&
                    e.preventDefault()
                  }
                  className={`${errors.people_capacity?.message ? "border-danger" : ""
                    } form-control`}
                  placeholder="Capacidad de personas"
                />
                {errors.people_capacity && (
                  <WizardError
                    error={errors.people_capacity.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                )}
              </Col>
            </Row>
            <Row form>
              <Col xs="auto" className="mr-2" tag={FormGroup}>
                <Label>¿Tarifa de alquiler?</Label>
                <Input
                  type="checkbox"
                  checked={rental}
                  onChange={({ target }) => {
                    setRental(target.checked);
                    setValue("rental_fee", null);
                  }}
                  className="position-relative m-0 ml-2 p-0"
                />
              </Col>
              <Col xs="auto" tag={FormGroup}>
                <Label>¿Tarifa de depósito?</Label>
                <Input
                  type="checkbox"
                  checked={deposit}
                  onChange={({ target }) => {
                    setDeposit(target.checked);
                    setValue("deposit_fee", null);
                  }}
                  className="position-relative m-0 ml-2 p-0"
                />
              </Col>
            </Row>
            <Row form>
              {rental && (
                <Col sm tag={FormGroup}>
                  <Label for="rental_fee">Monto de tarifa de alquiler</Label>
                  <NumberFormat
                    value={rentalFeeValue}
                    onValueChange={({ value }) => {
                      setValue("rental_fee", value);
                    }}
                    thousandSeparator
                    prefix={`${baseCurrency.symbol} `}
                    fixedDecimalScale
                    decimalScale={2}
                    className={`${errors.rental_fee?.message ? "border danger" : ""
                      } form-control`}
                    placeholder="Precio de renta"
                  />
                  <WizardError
                    error={errors.rental_fee?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              )}
              {deposit && (
                <Col sm tag={FormGroup}>
                  <Label for="deposit_fee">Monto de tarifa de depósito</Label>
                  <NumberFormat
                    value={depositFeeValue}
                    onValueChange={({ value }) => {
                      setValue("deposit_fee", value);
                    }}
                    thousandSeparator
                    prefix={`${baseCurrency.symbol} `}
                    fixedDecimalScale
                    decimalScale={2}
                    className={`${errors.deposit_fee?.message ? "border danger" : ""
                      } form-control`}
                    placeholder="Tarifa de depósito"
                  />
                  <WizardError
                    error={errors.deposit_fee?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              )}
            </Row>
            <FormGroup>
              <Label for="name">Descripción</Label>
              <Input
                autoComplete="off"
                name="description"
                innerRef={register({
                  minLength: {
                    value: 10,
                    message:
                      "La descripción debe tener al menos 10 carácteres.",
                  },
                })}
                type={"textarea"}
                className={classNames({
                  "border-danger": errors.description?.message,
                })}
                placeholder="Descripción del área"
              />
              <WizardError
                error={errors.description?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>
            <FormGroup>
              <FileUploadArea
                label="Imagen del área"
                accept="image/*"
                onChange={handleImageChange}
                preview={imagePreview}
                fileName={file?.name}
                onRemove={() => { setFile(null); setImagePreview(null); }}
                error={errors.picture?.message}
              />
            </FormGroup>
            <Row
              form
              className="align-items-center justify-content-center justify-content-md-end"
            >
              <ButtonIcon
                color="falcon-default"
                className="my-2 mx-0 mx-md-2 m-md-0 px-5 mr-2"
                icon={faUndo}
                onClick={() => history.goBack()}
                iconAlign="right"
                transform="down-1 shrink-4"
              >
                Volver
              </ButtonIcon>
              <ButtonIcon
                data-testid="submit-button"
                color="primary"
                className="my-2 mx-0 mx-md-2 m-md-0 px-5"
                type="submit"
                icon="save"
                iconAlign="right"
                /*      disabled={Object.keys(errors).length > 0} */
                transform="down-1 shrink-4"
              >
                {type === "create" ? "Guardar" : "Guardar cambios"}
              </ButtonIcon>
            </Row>
          </CardBody>
        </PreloadState>
      </Card>
    </>
  );
};

export default AreasCreate;
